module.exports = __webpack_public_path__ + "img/options.2101c061.svg";